<!--Header Start-->
<header id="rs-header" class="rs-header">
  <!-- Menu Start -->
  <!-- Topbar Area Start -->
  <top-bar></top-bar>
  <!-- Topbar Area End -->
  <!-- Menu Start -->
  <div class="menu-area menu-sticky">
    <div class="container">
      <div class="row y-middle">
        <div class="col-lg-2">
          <div class="logo-cat-wrap">
            <div class="logo-part">
              <a href="/">
                <img class="normal-logo" src="assets/college/sbesatp.png" alt="Sbes atp">
                <img class="sticky-logo" src="assets/college/sbesatp.png" alt="Sbes atp">
              </a>
            </div>
          </div>
        </div>
        <div class="col-lg-9 text-right">
          <div class="rs-menu-area">
            <div class="main-menu">
              <div class="mobile-menu">
                <a class="rs-menu-toggle">
                  <i class="fa fa-bars"></i>
                </a>
              </div>
              <nav class="rs-menu">
                <ul class="nav-menu">
                  <li class="menu-item" [class.active]="isHomeRoute()">
                    <a routerLink="/">Home</a>
                  </li>
                  <li class="menu-item-has-children" [class.active]="isAboutRoute()">
                    <a>About Us</a>
                    <ul class="sub-menu">
                      <li [class.active]="isActiveRoute('/about/sri-balaji-educational-society')"><a routerLink="/about/sri-balaji-educational-society">Society</a></li>
                      <li [class.active]="isActiveRoute('/about/founder')"><a routerLink="/about/founder">Founder</a></li>
                      <li [class.active]="isActiveRoute('/about/chairman')"><a routerLink="/about/chairman">Chariman</a></li>
                      <li [class.active]="isActiveRoute('/about/treasurer')"><a routerLink="/about/treasurer">Treasurer</a></li>
                      <li [class.active]="isActiveRoute('/about/management')"><a routerLink="/about/management">Management Team</a></li>
                      <li [class.active]="isActiveRoute('/about/faqs')"><a routerLink="/about/faqs">Faqs</a></li>
                    </ul>
                  </li>
                  <li class="menu-item" [class.active]="isActiveRoute('/our-colleges')">
                    <a routerLink="/our-colleges">OUR Colleges</a>
                  </li>
                  <li class="menu-item" [class.active]="isActiveRoute('/balaji-sevasamithi')">
                    <a routerLink="/balaji-sevasamithi">Balaji Sevasamithi</a>
                  </li>
                  <li class="menu-item" [class.active]="isActiveRoute('/contact')">
                    <a routerLink="/contact">Contact</a>
                  </li>
                </ul>
              </nav>
            </div> <!-- //.main-menu -->
          </div>
        </div>
        <div class="col-lg-1 text-right">
          <div class="expand-btn-inner">

            <a id="nav-expander" class="nav-expander style6">
              <span class="dot1"></span>
              <span class="dot2"></span>
              <span class="dot3"></span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Menu End -->
  <nav class="right_menu_togle hidden-md">
    <div class="close-btn">
      <div id="nav-close">
        <div class="line">
          <span class="line1"></span><span class="line2"></span>
        </div>
      </div>
    </div>
    <div class="canvas-logo">
      <a href="/">
        <img src="assets/college/sbesatp.png" alt="Sbes atp">
      </a>
    </div>
    <div class="offcanvas-text">
      <p>We denounce with righteous indige nationality and dislike men who are so beguiled and demo  by the charms of pleasure of the moment data com so blinded by desire.</p>
    </div>
    <div class="offcanvas-gallery">
      <div class="gallery-img">
        <a class="image-popup" href="assets/images/gallery/1.jpg"><img src="assets/images/gallery/1.jpg" alt=""></a>
      </div>
      <div class="gallery-img">
        <a class="image-popup" href="assets/images/gallery/2.jpg"><img src="assets/images/gallery/2.jpg" alt=""></a>
      </div>
      <div class="gallery-img">
        <a class="image-popup" href="assets/images/gallery/3.jpg"><img src="assets/images/gallery/3.jpg" alt=""></a>
      </div>
      <div class="gallery-img">
        <a class="image-popup" href="assets/images/gallery/4.jpg"><img src="assets/images/gallery/4.jpg" alt=""></a>
      </div>
      <div class="gallery-img">
        <a class="image-popup" href="assets/images/gallery/5.jpg"><img src="assets/images/gallery/5.jpg" alt=""></a>
      </div>
      <div class="gallery-img">
        <a class="image-popup" href="assets/images/gallery/6.jpg"><img src="assets/images/gallery/6.jpg" alt=""></a>
      </div>
    </div>
    <div class="map-img">
      <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3492.6345768924857!2d77.6020918!3d14.685038799999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bb14ad9f8111341%3A0x926a830ae2e9511b!2sSRI%20BALAJI%20EDUCATIONAL%20SOCIETY!5e1!3m2!1sen!2sin!4v1773927592595!5m2!1sen!2sin" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
    </div>
    <div class="canvas-contact">
      <ul class="social">
        <li><a href="https://www.facebook.com/SbesAtp"><i class="fa fa-facebook"></i></a></li>
        <li><a href="#"><i class="fa fa-twitter"></i></a></li>
        <li><a href=""><i class="fa fa-instagram"></i></a></li>
        <li><a href="#"><i class="fa fa-linkedin"></i></a></li>
      </ul>
    </div>
  </nav>
</header>
<!--Header End-->
